module.exports = __webpack_public_path__ + "static/media/terraspeak-1.5b24812b.jpg";